export default {"src":"/_next/static/media/cta-qr-left-nav.c878b013.svg","height":300,"width":300,"blurWidth":0,"blurHeight":0};